<template>
<svg :width="size" :height="size" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" :style="`transform: rotate(${rotate})`">
    <path d="M9 6.33368V8.11145C9 8.3472 8.90635 8.57329 8.73965 8.73999C8.57295 8.90669 8.34686 9.00034 8.11111 9.00034H1.88889C1.65314 9.00034 1.42705 8.90669 1.26035 8.73999C1.09365 8.57329 1 8.3472 1 8.11145V6.33368" :stroke="color" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.77736 4.1111L4.99958 6.33331L7.2218 4.1111" :stroke="color" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4.99915 6.33331L4.99915 0.999999" :stroke="color" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: '10'
        },
        color: {
            required: false,
            type: String,
            default: '#727D94'
        },
        rotate:{
            type: String,
            default: '0deg'
        }
    }
}
</script>

<style>

</style>
